app.directive('focusOnRender', ($timeout) => {
	return {
		restrict: 'A',
		link: (scope, element) => {
			// after a brief delay, focus the element
			$timeout(() => element.trigger('focus'), 750);
		}
	};
});
